export { default as NewsContainer } from './NewsContainer';
